import { HttpErrorResponse } from '@angular/common/http';
import { ApiResponseError } from './api-response';

export function httpErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiResponseError) {
    return responseMessage(error.message, error.errors, fallback);
  }

  if (!(error instanceof HttpErrorResponse)) {
    if (error instanceof Error && error.message.trim()) return error.message;
    return fallback;
  }

  const apiError = error.error;

  if (typeof apiError === 'string') {
    return apiError.trim() || fallback;
  }

  if (!apiError || typeof apiError !== 'object') {
    return fallback;
  }

  const err = apiError as {
    message?: unknown;
    detail?: unknown;
    title?: unknown;
    errors?: unknown;
  };

  const details = validationErrors(err.errors);

  if (typeof err.message === 'string' && err.message.trim()) {
    return responseMessage(err.message, err.errors, fallback);
  }

  if (typeof err.detail === 'string' && err.detail.trim()) {
    return err.detail;
  }

  if (typeof err.title === 'string' && err.title.trim()) {
    return err.title;
  }

  if (Array.isArray(err.errors)) {
    return details || fallback;
  }

  if (err.errors && typeof err.errors === 'object') {
    return details || fallback;
  }

  return fallback;
}

function responseMessage(message: string, errors: unknown, fallback: string): string {
  const summary = message.trim();
  const details = validationErrors(errors);
  if (details && (!summary || /validation failed/i.test(summary))) {
    return summary ? `${summary} ${details}` : details;
  }
  return summary || details || fallback;
}

function validationErrors(errors: unknown): string {
  if (Array.isArray(errors)) {
    return errors
      .map((error) =>
        typeof error === 'object' && error !== null && 'message' in error
          ? String((error as { message: unknown }).message)
          : String(error),
      )
      .filter(Boolean)
      .join(', ');
  }

  if (errors && typeof errors === 'object') {
    return Object.values(errors).flat().map(String).filter(Boolean).join(', ');
  }

  return '';
}
